module.exports = __webpack_public_path__ + "img/ic1.758072a8.svg";